import { Link } from "react-router-dom";

const seededRandBetween = (seed, min, max) => {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (Math.imul(31, h) + seed.charCodeAt(i)) | 0;
  }
  return min + (Math.abs(h) % (max - min + 1));
};

const LABEL_CONFIG = {
  trending: { text: "🔥 Trending", style: "bg-rose-500/20 text-rose-300 border border-rose-500/40" },
  "sports-event": { text: "🏆 Live Event", style: "bg-amber-500/20 text-amber-300 border border-amber-500/40" },
  holiday: { text: "🎉 Holiday", style: "bg-pink-500/20 text-pink-300 border border-pink-500/40" },
  seasonal: { text: "🍂 Seasonal", style: "bg-teal-500/20 text-teal-300 border border-teal-500/40" },
};

const PERSONALITY_PILL = {
  text: "✨ Personality",
  style: "bg-violet-500/20 text-violet-300 border border-violet-500/40",
};

const difficultyCopy = {
  easy: "Easy",
  "easy-medium": "Easy-Medium",
  medium: "Medium",
};

const difficultyStyles = {
  easy: "bg-green-500/20 text-green-300 border border-green-500/40",
  "easy-medium": "bg-yellow-500/20 text-yellow-300 border border-yellow-500/40",
  medium: "bg-orange-500/20 text-orange-300 border border-orange-500/40",
};

const formatCategoryLabel = (category) => {
  if (!category) return "General";
  return category
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const QuizCard = ({ quiz }) => {
  const playedToday = seededRandBetween(quiz.slug, 444, 3489);
  return (
  <article className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-white/5 text-left shadow-xl shadow-slate-900/40 transition hover:border-brand-glow/60 hover:bg-white/10">
    <Link to={`/quiz/${quiz.slug}`} className="relative z-10 block">
      {quiz.image ? (
        <img
          src={quiz.image}
          alt={quiz.title}
          className="h-44 w-full object-cover"
          loading="lazy"
        />
      ) : (
        <div className="flex h-44 w-full items-center justify-center rounded-t-2xl bg-gradient-to-br from-brand-glow/30 to-purple-900/40">
          <span className="text-white/60 text-sm uppercase tracking-[0.4em]">
            {formatCategoryLabel(quiz.category)}
          </span>
        </div>
      )}
    </Link>
    <div className="flex flex-1 flex-col justify-between p-5">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          {quiz.quiz_type === "personality" && (
            <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold tracking-wide ${PERSONALITY_PILL.style}`}>
              {PERSONALITY_PILL.text}
            </span>
          )}
          {quiz.label && LABEL_CONFIG[quiz.label] && (
            <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold tracking-wide ${LABEL_CONFIG[quiz.label].style}`}>
              {LABEL_CONFIG[quiz.label].text}
            </span>
          )}
          <Link
            to={`/category/${encodeURIComponent(quiz.category)}`}
            className="relative z-10 inline-flex items-center rounded-full border border-brand-glow/50 bg-brand-glow/30 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white transition hover:border-brand-glow hover:bg-brand-glow/40"
          >
            {formatCategoryLabel(quiz.category)}
          </Link>
          <span
            className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${
              difficultyStyles[quiz.difficulty] || "bg-white/10 text-white/80 border border-white/30"
            }`}
          >
            {difficultyCopy[quiz.difficulty] || quiz.difficulty}
          </span>
        </div>
        <h2 className="mt-4 text-2xl font-semibold text-white">{quiz.title}</h2>
        <p className="mt-2 text-white/70">{quiz.description}</p>
      </div>
      <div className="mt-6 flex items-center justify-between gap-3">
        <Link
          to={`/quiz/${quiz.slug}`}
          className="after:absolute after:inset-0 inline-flex items-center justify-center rounded-full bg-brand-glow px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-brand-glow/40 transition group-hover:translate-y-[1px]"
        >
          Take the quiz
        </Link>
        <span className="relative z-10 shrink-0 text-xs text-white/50">
          🔥{playedToday.toLocaleString()} people played today
        </span>
      </div>
    </div>
  </article>
  );
};

export default QuizCard;
